import type { RouteLocationNormalized } from "vue-router";
import axios from "axios";
import { csContext } from "../../services/cs-context";
import { TeamEffectivenessReviewApiModel, TeamEffectivenessReportApiModel } from "../../api-models";

export function getTeamEffectivenessReportReviewId(
  currentRoute: RouteLocationNormalized,
  specificTeamId?: string,
): string | undefined {
  return currentRoute?.params?.id as string;
}

export function getTeamEffectivenessReportTeamId(
  currentRoute: RouteLocationNormalized,
  specificTeamId?: string,
): string | undefined {
  return (specificTeamId || currentRoute?.params?.team || csContext.currentTeam?.id) as string;
}

export function getTeamEffectivenessReportFlexible(
  reviewId?: string,
  teamId?: string,
): Promise<TeamEffectivenessReportApiModel | null> {
  const sharedCode = new URL(window.location.href).searchParams.get("sharedcode");
  return axios
    .get<TeamEffectivenessReportApiModel>("/api/teameffectivenessreport/", {
      params: {
        reviewId,
        teamId,
        sharedCode,
      },
    })
    .then((r) => {
      if (!!r && r.data) {
        return r.data as TeamEffectivenessReportApiModel;
      }
      return null;
    });
}

export function getTeamEffectivenessReport(
  reviewId?: string,
): Promise<TeamEffectivenessReviewApiModel> {
  const sharedCode = new URL(window.location.href).searchParams.get("sharedcode");
  return axios
    .get<TeamEffectivenessReportApiModel>("/api/teameffectivenessreport/", {
      params: {
        reviewId,
        sharedCode,
      },
    })
    .then((r) => {
      if (!!r && r.data && r.data.review) {
        return r.data.review;
      }
      throw new Error(
        `Failed to load team effectiveness report with review ID '${reviewId}' and shared code '${sharedCode}'`,
      );
    });
}
